import { Team__Cerveceras } from "../teams/Cerveceras";
import { Team__Omega } from "../teams/Omega";
import { Team__UTPaquime } from "../teams/UTPaquime";
import { Team__Abejas } from "../teams/Abejas";

const Cerveceras = {
  team: Team__Cerveceras,
  playingPlayers: [],

  goals: 20,
  penaltyGoals: 0,
  isWinner: false,
};

const Omega = {
  team: Team__Omega,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const UTPaquime = {
  team: Team__UTPaquime,
  playingPlayers: [],

  goals: 22,
  penaltyGoals: 0,
  isWinner: false,
};

const Abejas = {
  team: Team__Abejas,
  playingPlayers: [],

  goals: 61,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada1 = {
  jornadaPosition: 1,
  matches: [
    {
      team1: Cerveceras,
      team2: Omega,

      isCompleted: true,
      isPlaying: false,
      day: "Lunes",
      date: "2026-07-27",
      time: "10:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: UTPaquime,
      team2: Abejas,

      isCompleted: true,
      isPlaying: false,
      day: "Lunes",
      date: "2026-07-27",
      time: "13:00:00",
      location: "Centro Recreativo Lebaron",
    }
  ],
};
